import React from "react";

import { EmbedBlock as EmbedBlockValue } from "@reactivated";

export const EmbedBlock = (props: {
    value: EmbedBlockValue;
    className?: string | null;
}) => {
    const _props = {
        className: props.className,
        dangerouslySetInnerHTML: {
            __html: props.value,
        },
    };
    return React.createElement("div", _props);
};
